module.exports = __webpack_public_path__ + "media/images/logo-one-color-8a91de0c58c133ca17a6201f0b36aa95.svg";